import mobileAdjustment from "../GeneralMobileAdjustments";

class MobileTimeInputControlView {

    constructor() { }

    afterRender(control){
        let element = mobileAdjustment.adjustMobileControl(control)[0];
        const height = mobileAdjustment.calculateHeight(control);
        
        element.style.height = "calc(100% - 8px)";
        element.lastElementChild.style.height = `${height}px`;
        element.lastElementChild.style.marginTop = element.style.marginTop;
        element.lastElementChild.style.marginBottom = element.style.marginBottom;

        element.firstElementChild.style.height = `${height+1}px`;
        element.firstElementChild.style.lineHeight  = "normal";
        element.firstElementChild.style.marginBottom = "6px";
    }
}

const mobileTimeInputControlView = new MobileTimeInputControlView();
export default mobileTimeInputControlView;